import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-checkbox-group',
  templateUrl: './fpx-checkbox-group.component.html',
  styleUrls: ['./fpx-checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxCheckboxGroupComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxCheckboxGroupComponent extends BaseFpxControlComponent {
  dataList: any;
  @Input() direction: 'horizontal' | 'vertical' = 'vertical';
  constructor(_controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef) {
    super(_controlContainer, changeDetectorRef);
  }

  update(checked: boolean, value: string | number,text:string) {
    const oldValue = this.formControl.value || [];
    if (!checked) {
      this.formControl.setValue(
        oldValue.filter((x: string | number) => x != value)
      );
    } else {
      this.formControl.setValue(
        this.dataList
          .filter(
            (x: any) => x.id == value || oldValue.indexOf(x.id) >= 0
          )
          .map((x) => x.id)
          //  .map((x) => x.text)
      );
    }
  }

  setDataList(_dataList: any) {
    this.dataList = _dataList;
  }

}
